import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Land from './pages/Land';
import Vision from './pages/Vision';
import Lots from './pages/Lots';
import Calculator from './pages/Calculator';
import Reserve from './pages/Reserve';
import NotFound from './pages/NotFound';

function BlogRedirect() {
  window.location.replace('https://www.costanativa.co/blog');
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <div className="min-h-screen bg-cream text-ink flex flex-col">
      <ScrollToTop />
      <Navbar />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/land" element={<Land />} />
          <Route path="/vision" element={<Vision />} />
          <Route path="/lots" element={<Lots />} />
          <Route path="/calculator" element={<Calculator />} />
          <Route path="/reserve" element={<Reserve />} />
          <Route path="/blog" element={<BlogRedirect />} />
          <Route path="/blog/:slug" element={<BlogRedirect />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
